export default __webpack_public_path__ + "static/Metropolis-ExtraBoldItalic-2b70b5e961d410ef14c64400a17b8313.woff2";